export const PAYMENT_AGES = {
  0: 'None',
  1: '0 - 30 days',
  2: '31- 60 days',
  3: '61- 90 days',
  4: '90+ days',
};

export const COMMUNICATION_TYPES = {
  EMAIL: 1,
  SMS: 2,
  BOTH: 3,
};

export const PAYMENT_FREQUENCY = {
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
};

export const DURATION_OR_AMOUNT = {
  DURATION: 'DURATION',
  AMOUNT: 'AMOUNT',
};

export const PAYMENT_METHODS = ['CC', 'ACH'];
export const YES_NO = ['YES', 'NO'];
export const AMOUNT_PERCENTAGE = ['AMOUNT', 'PERCENTAGE'];

export const MAIN_PAYMENT_METHODS = {
  SAVED_CARD: 'SAVED_CARD', //Payment Method on File
  PHYSICAL_TERMINAL: 'PHYSICAL_TERMINAL',
  VIRTUAL_TERMINAL: 'VIRTUAL_TERMINAL',
  PAYMENT_LINK: 'PAYMENT_LINK',
  ACH_OR_E_CHECK: 'ACH_OR_E_CHECK',
  CHECK: 'CHECK',
  CASH: 'CASH',
  PAYMENT_PLAN: 'PAYMENT_PLAN',
};

export enum PAYMENT_COLLACTION_TYPE {
  SavedCards = 1, //Payment Method on File  //Do not remove it is used only for set default method.
  VirtualTerminal = 2,
  PhysicalTerminal = 3,
  Cash = 4,
  Check = 5,
  ACH = 6,
  PaymentLink = 7,
  PayNow = 8,
}

export const MAIN_PAYMENT_METHODS_DROPDOWN = {
  SAVED_CARD: 'Payment Method on File',
  PHYSICAL_TERMINAL: 'Physical Terminal',
  VIRTUAL_TERMINAL: 'Virtual Terminal',
  PAYMENT_LINK: 'Payment Link',
  ACH_OR_E_CHECK: 'ACH/e-check',
  // CHECK: 'Check',
  // CASH: 'Cash',
};

export const MAIN_PAYMENT_METHODS_FILTER_DROPDOWN = {
  1: 'Saved Cards',
  2: 'Virtual Terminal',
  3: 'Physical Terminal',
  4: 'Cash',
  5: 'Check',
  6: 'ACH/e-check',
  7: 'Payment Link',
  8: 'Pay Now',
};

export const PAYMENT_TYPES = {
  PATIENT_PORTION: 'PATIENT_PORTION',
  PRE_PAYMENT: 'PRE_PAYMENT',
};

export const INITIAL_PAYMENT_CALCULATION_TYPES = {
  AMOUNT: 'AMOUNT',
  PERCENTAGE: 'PERCENTAGE',
  NONE: 'NONE',
};

export const PAYMENT_STATUSES = {
  '': 'None',
  'Fully Paid': 'Fully Paid',
  Unpaid: 'Unpaid',
  'Over Paid': 'Over Paid',
};

export const PAYMENT_STATUSES_FILTER = {
  0: 'None',
  1: 'Fully Paid',
  2: 'Unpaid',
  3: 'Over Paid',
};

export const PAYMENT_WEEK_DAYS = [
  'SUN',
  'MON',
  'TUE',
  'WED',
  'THU',
  'FRI',
  'SAT',
];

export const PAYMENT_MONTH_DAYS_WEEK = ['1st', '2nd', '3rd', '4th', 'Last'];

export const CARD_TYPES = {
  VISA: 'VISA',
  AMEX: 'AMEX',
  MASTER: 'MASTERCARD',
  DISCOVER: 'DISCOVER',
  DINERS: 'DINERS CLUB',
  JCB: 'JCB',
};

export const EMI_STATUSES = {
  PENDING: 0,
  PAID: 1,
  OVERDUE: 2,
  FAILED: 3,
};
export enum TRANSACTIONS_TYPES{
  CreditCard = 1,
  ACH = 2,
  Cash = 3,
  Check = 4,
}


export const TRANSACTION_TYPES = {
  // 1: 'Cash',
  // 2: 'CreditCard',
  // 3: 'POS',
  // 4: 'Check',
  // 5: 'ACH',
  // 6: 'PaymentLink',
  // 7: 'PrePayment',
  1: 'Credit Card',
  2: 'ACH',
  3: 'Cash',
  4: 'Check',
};

export const WRITE_BACK_STATUSES_DROPDOWN = {
  0: 'Pending',
  1: 'Success',
  2: 'Failed',
  3: 'Duplicate',
  4: 'Skipped'
};

export enum WRITE_BACK_STATUSES{
  Pending = 0,
  Success = 1,
  Failed = 2,
  Duplicate = 3,
  Skipped = 4 
}

export const TRANSACTION_PAYMENT_STATUSES = {
  true: 'Success',
  false: 'Failed',
};

export const PaymentPlanSpecificRelativeDay = {
  SPECIFIC_DAY: 1,
  RELATIVE_DAY: 2,
};

export const PAY_NOW_LOOKUP_TYPE = {
  0: 'All',
  1: 'With',
  2: 'Without',
};

export const FINAL_PAYMENT_STATUS = {
  Initiated: 0,
  Success: 1,
  Failed: 2,
};

export const Owner_Type = {
  Patient: 1,
  Practice: 2
}


export const ORDER_STATUS = {
  Created: 1,
  Completed: 2,
  Cancelled: 3
} 
export const PREFERENCE={
  Primary:1,
  Secondary:0
}

export const PAYMENT_STATUS_DROPDOWN = {
  0: 'Link Sent',
  1: 'Success',
  2: 'Failed',
  3: 'Refunded',
  4: 'Refund Failed',
};

export enum AR_BUCKET{
  None = 0,
  ZeroToThirtyDay = 1,
  ThirtyOneToSixtey = 2,
  SixteyOneToNinety = 3,
  NinetyPlus = 4
}

export enum PAYMENT_STATUS_FILTER {
  All = 0,
  Paid = 1,
  Unpaid = 2
}

export enum TRANSACTION_ADVANDED_FILTER_KEY {
  PaymentType = 0,
  PaymentCollection = 0,
  Module = 0,
  PaymentStatus = -1,
  WritebackStatus = ''
}

export enum PATINET_WITH_PP_REPORT_ADVANCED_FILTER_KEY {
  PaymentPlan = 0
}

export enum EMI_TRANSACTION_TYPE
{
  InitialAmount = 1,
  Installment = 2,
  OneTimeAdjustment = 3
}

export const PAYMENT_PLAN_STATUS = {
  Active: 0,
  Closed: 1,
  Cancelled: 2
} 